/** Push notification kinds a user can switch on and off (PLAN.md §11). */
export const NOTIFICATION_KINDS = ['import', 'cook', 'shopping', 'prep', 'inbox'] as const;
export type NotificationKind = (typeof NOTIFICATION_KINDS)[number];

export interface NotificationPrefValues {
  enabled: boolean;
  /** `HH:MM`; null for kinds without a time (import). */
  time: string | null;
  /** Cook reminders: 0 = on the day, 1 = the evening before. Prep-ahead: always 1. */
  dayOffset: 0 | 1;
  /** Shopping reminders: ISO weekday; null = the household's shopping day. */
  weekday: number | null;
}

/** What a user gets before changing anything. */
export const DEFAULT_NOTIFICATION_PREFS: Record<NotificationKind, NotificationPrefValues> = {
  import: { enabled: true, time: null, dayOffset: 0, weekday: null },
  cook: { enabled: true, time: '09:00', dayOffset: 0, weekday: null },
  shopping: { enabled: true, time: '09:00', dayOffset: 0, weekday: null },
  /** The evening before a cook session whose recipe needs work ahead (P4.01). */
  prep: { enabled: true, time: '19:00', dayOffset: 1, weekday: null },
  /** A friend suggested a recipe (P4.05). */
  inbox: { enabled: true, time: null, dayOffset: 0, weekday: null },
};
